import type { SVGProps } from 'react';

export const AmexLogo = (props: SVGProps<SVGSVGElement>) => (
    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 40" {...props}>
        <g id="Layer_1-2" data-name="Layer 1">
            <path
                fill="#0071ce"
                d="M60,6v28c0,.57-.08,1.11-.23,1.63-.03.12-.07.25-.12.37-.81,2.33-3.04,4-5.65,4H6c-3.31,0-6-2.69-6-6V6C0,2.69,2.69,0,6,0h48c2.99,0,5.48,2.2,5.92,5.07.01.02.01.03.01.05.05.29.07.58.07.88Z"
            />
            <rect fill="#fff" x="24.8" y="5.07" width="35.2" height="30.93" />
            <path
                fill="#0071ce"
                d="M55.52,33.92h4.48l-5.87-6.29,5.87-6.19h-4.37l-3.73,4.05-3.63-4.05h-4.48l5.97,6.29-5.97,6.19h4.37l3.73-4.05,3.63,4.05Z"
            />
            <path
                fill="#0071ce"
                d="M36.64,31.04v-1.92h7.04v-2.88h-7.04v-1.92h7.15v-2.88h-10.56v12.48h10.56v-2.88h-7.15Z"
            />
            <path
                fill="#0071ce"
                d="M56.69,19.63h3.2V7.04l-5.12.11-2.77,7.79-2.88-7.79h-5.33v12.48h3.41v-8.75l3.2,8.75h2.99l3.31-8.75v8.75Z"
            />
            <path
                fill="#0071ce"
                d="M43.79,19.4l-5.44-12.25h-4.38l-5.54,12.48h3.73l1.07-2.46h5.76l1.06,2.46h3.84l-.1-.23ZM34.4,14.29l1.71-4.05,1.7,4.05h-3.41Z"
            />
            <path
                fill="#0071ce"
                d="M32.69,5.12l-7.04,16.11h5.66v14.4h17.81l2.88-3.1,2.77,3.1h5.23v.37h-.35c-.81,2.33-3.04,4-5.65,4h-30.59V0h30.59c2.99,0,5.48,2.2,5.92,5.07h.08v.05h-6.51l-1.49,4.16-1.49-4.16h-8.54v5.55l-2.45-5.55h-6.83Z"
            />
            <path fill="#0071ce" d="M56.91,27.31l3.09,3.41v-6.83l-3.09,3.41Z" />
        </g>
    </svg>
);
